//TODO: might try dynamic component loading at a later time.

//#region Components Imports
//#region MainMenus
import ActionsContext from './WebHooks/WebHooksHelpers/ActionsContext.svelte';
import ActionsContextV2 from './WebHooks/WebHooksHelpers/ActionsContextV2.svelte';
import AdcActions from './WebHooks/WebHooksG1/AdcActions.svelte';
import AdcAutomation from './ExternalSensorSettings/AdcAutomation.svelte';
import ScheduleSettings from './Schedules/SchedulesG1/SchedulesG1.svelte';
import SchedulesG1V2 from './Schedules/SchedulesG1/SchedulesG1V2.svelte';
import SensorActions from './WebHooks/WebHooksG1/SensorActions.svelte';
import SchedulesTrv from './Schedules/SchedulesTRV/SchedulesTrv.svelte'; //this will be moved in device page at charts place
//#endregion MainMenus

//#region SubMenus

//#region Timers
import Auto from './Timers/TimersG1/Auto.svelte';
import AutoV2 from './Timers/TimersG1/AutoV2.svelte';
//#endregion Timers

//#region Effects
import ControlEffects from '../Controls/Single/ControlEffects.svelte';
//#endregion Effects
//#region ScheduleSettings
// import SchedulesEnable from './DeviceSettings/SchedulesEnable.svelte';
// import SchedulesList from './DeviceSettings/SchedulesList.svelte';
//#endregion ScheduleSettings

//#region SensorSettingsG1
//DoorWindow
import IlluminationThreshold from './SensorSettingsG1/DoorWindow/IlluminationThreshold.svelte';
import ReverseOpenCloseLogic from './SensorSettingsG1/DoorWindow/ReverseOpenCloseLogic.svelte';
import TiltFunctions from './SensorSettingsG1/DoorWindow/TiltFunctions.svelte';
import Vibration from './SensorSettingsG1/DoorWindow/Vibration.svelte';
import WakeUpByLighting from './SensorSettingsG1/DoorWindow/WakeUpByLighting.svelte';
//Flood
import RainMode from './SensorSettingsG1/Flood/RainMode.svelte';
//Gas
import Valve from './SensorSettingsG1/Gas/Valve.svelte';
//Motion
import MotionIlluminationDefinitions from './SensorSettingsG1/Motion/MotionIlluminationDefinitions.svelte';
import MotionSettings from './SensorSettingsG1/Motion/MotionSettings/MotionSettings.svelte';
import MotionConfigurationG4 from './SensorSettingsG2/Motion/MotionConfigurationG4.svelte';
import MotionSensorSettingsG4 from './SensorSettingsG2/Motion/MotionSensorSettingsG4.svelte';
import PresenceUISettingsG4 from './SensorSettingsG2/Motion/PresenceUISettingsG4.svelte';
import SleepTime from './SensorSettingsG1/Motion/SleepTime.svelte';
import TamperSensitivity from './SensorSettingsG1/Motion/TamperSensitivity.svelte';
//Sense
import MotionDuration from './SensorSettingsG1/Sense/MotionDuration.svelte';
import MotionLed from './SensorSettingsG1/Sense/MotionLed.svelte';
//Trv
import AutoTControlTrv from './SensorSettingsG1/Trv/AutoTControlTrv.svelte';
import OpenWindow from './SensorSettingsG1/Trv/OpenWindow.svelte';
import TemperatureOffsetTrv from './SensorSettingsG1/Trv/TemperatureOffsetTrv.svelte';
//SensorSettings
import ExternalPower from './SensorSettingsG1/ExternalPower.svelte';
import HumidityOffset from './SensorSettingsG1/HumidityOffset.svelte';
import HumidityThreshold from './SensorSettingsG1/HumidityThreshold.svelte';
import TemperatureOffset from './SensorSettingsG1/TemperatureOffset.svelte';
import TemperatureThreshold from './SensorSettingsG1/TemperatureThreshold.svelte';
import TemperatureUnits from './SensorSettingsG1/TemperatureUnits.svelte';
//#endregion SensorSettingsG1

//#region SensorSettingsG2
//PlusHT
import TemperatureUnitG2 from './SensorSettingsG2/TemperatureUnits.svelte';
import HumidityOffsetG2 from './SensorSettingsG2/Offset/HumidityOffsetG2.svelte';
import TemperatureOffsetG2 from './SensorSettingsG2/Offset/TemperatureOffsetG2.svelte';
import HumidityThresholdG2 from './SensorSettingsG2/HumidityThreshold.svelte';
import TemperatureThresholdG2 from './SensorSettingsG2/TemperatureThreshold.svelte';
import BrightThresholdG2 from './SensorSettingsG2/Illuminance/BrightThresholdG2.svelte';
import DarkThresholdG2 from './SensorSettingsG2/Illuminance/DarkThresholdG2.svelte';
import SensorComponentNameG2 from './SensorSettingsG2/SensorComponentNameG2.svelte';
import VentoraSensorSettingsGroup from './SensorSettingsG2/Ventora/VentoraSensorSettingsGroup.svelte';
//#endregion SensorSettingsG2

//#region ExternalSensorActions
import ExtTemperatureOffset from './ExternalSensorSettings/ExtTemperatureOffset.svelte';
import ExtSensorNames from './ExternalSensorSettings/ExtSensorNames.svelte';
import ExtHumidityOffset from './ExternalSensorSettings/ExtHumidityOffset.svelte';
import ExtTemperatureUnit from './ExternalSensorSettings/ExtTemperatureUnit.svelte';
import TemperatureAutomation from './ExternalSensorSettings/TemperatureAutomation.svelte';
import HumidityAutomation from './ExternalSensorSettings/HumidityAutomation.svelte';
//#endregion

//#region addonsG2
import EnableAddon from './AddonSettingsG2/EnableAddon.svelte';
//#endregion

//#region Input Counter PlusUni G2
import PlusUniCounterSettings from './PlusUniCounterSettings/PlusUniCounterSettings.svelte';
//#endregion

//#region NetworkG1
import AdvancedDevSettings from './NetworkG1/AdvancedDevSettings.svelte';
import Cloud from './NetworkG1/Cloud.svelte';
import WifiApRoaming from './NetworkG1/WifiApRoaming.svelte';
import WifiClientBackup from './NetworkG1/WifiClientBackup.svelte';
import WifiModeClient from './NetworkG1/WifiModeClient.svelte';
import WifiModeAp from './NetworkG1/WifiModeAp.svelte';
import WifiReconnect from './NetworkG1/WifiReconnect.svelte';
import RestrictLogin from './NetworkG1/RestrictLogin.svelte';
//#endregion NetworkG1

//#region Safety
import ObstacleDetection from './Safety/SafetyG1/ObstacleDetection.svelte';
import PowerProtection from './Safety/SafetyG1/PowerProtection.svelte';
import PowerProtectionRoller from './Safety/SafetyG1/PowerProtectionRoller.svelte';
import SafetySwitch from './Safety/SafetyG1/SafetySwitch.svelte';
import PowerProtectionEM3 from './Safety/SafetyG1/PowerProtectionEM3.svelte';
//#endregion Safety

import Favorites from './Favorites.svelte';

//#region Settings
// import ApplianceTypeG1 from './Settings/SettingsG1/ApplianceTypeG1.svelte';
import Antiflickering from './Settings/SettingsG1/Antiflickering.svelte';
import AdcOffset from './Settings/SettingsG1/AdcSettings/AdcOffset.svelte';
import AdcRange from './Settings/SettingsG1/AdcSettings/AdcRange.svelte';
import BoostTime from './Settings/SettingsG1/TRV/BoostTime.svelte';

import BtnType from './Settings/SettingsG1/ButtonTypes/BtnType.svelte';
import BtnType1L from './Settings/SettingsG1/ButtonTypes/BtnType1L.svelte';
import BtnType1L2 from './Settings/SettingsG1/ButtonTypes/BtnType1L2.svelte';
import BtnTypeInputsReader from './Settings/SettingsG1/ButtonTypes/BtnTypeInputsReader.svelte';
import BtnTypePM from './Settings/SettingsG1/ButtonTypes/BtnTypePM.svelte';
import BtnTypeRGBW2 from './Settings/SettingsG1/ButtonTypes/BtnTypeRGBW2.svelte';
import BtnTypeRGBW2White from './Settings/SettingsG1/ButtonTypes/BtnTypeRGBW2White.svelte';
import BtnTypeRoller from './Settings/SettingsG1/ButtonTypes/BtnTypeRoller.svelte';
import BtnTypeRR from './Settings/SettingsG1/ButtonTypes/BtnTypeRR.svelte';

import ButtonDebounce from './Settings/SettingsG1/ButtonDebounce.svelte';
import ButtonFade from './Settings/SettingsG1/ButtonFade.svelte';
import CalibrationTrv from './Settings/SettingsG1/TRV/CalibrationTrv.svelte';
import ClogPrevention from './Settings/SettingsG1/TRV/ClogPrevention.svelte';
import ConsumptionCorrection from './Settings/SettingsG1/ConsumptionCorrection.svelte';
import ConsumptionIndicator from './Settings/SettingsG1/ConsumptionIndicator.svelte';
import ChannelName from './Settings/SettingsG1/ChannelName.svelte';
import CustomizeDeviceContent from './CustomizeDeviceContent/CustomizeDeviceContent.svelte';
import DCSupply from './Settings/SettingsG1/DCSupply.svelte';
import DeviceName from './Settings/SettingsG1/DeviceName.svelte';
import DeviceModel from './Settings/SettingsG1/DeviceModel.svelte';
import EcoMode from './Settings/SettingsG1/EcoMode.svelte';
import EndsDelay from './Settings/SettingsG1/EndsDelay.svelte';
import ModeRGBW2 from './Settings/SettingsG1/ModeRGBW2.svelte';
import DimmerCalibration from './Settings/SettingsG1/DimmerCalibration.svelte';
import Display from './Settings/SettingsG1/TRV/Display.svelte';
import DWLightControl from './Settings/SettingsG1/DWLightControl.svelte';
import EraseData from './Settings/SettingsG1/EraseData.svelte';
import ExternalSwitch from './Settings/SettingsG1/ExternalSwitch.svelte';

import FactoryResetG1 from './Settings/SettingsG1/FactoryResetG1.svelte';
import ForceCloseTrv from './Settings/SettingsG1/TRV/ForceCloseTrv.svelte';
import InputBtnsMode from './Settings/SettingsG1/ButtonTypes/InputBtnsMode.svelte';
import ChildLock from './Settings/SettingsG1/TRV/ChildLock.svelte';
import LongPush from './Settings/SettingsG1/LongPush.svelte';
import LongPushInputs from './Settings/SettingsG1/LongPushInputs.svelte';
import MosLightControl from './Settings/SettingsG1/MosLightControl.svelte';
import MinBrightness from './Settings/SettingsG1/MinBrightness.svelte';
import Mode from './Settings/SettingsG1/Mode.svelte';
import MultiPush from './Settings/SettingsG1/MultiPush.svelte';
import NeutralMismatch from './Settings/SettingsG1/NeutralMismatch.svelte';
// import NewSensorActions from './WebHooks/WebHooksG1/NewSensorActions.svelte';
import NightMode from '../DevicesSettings/NightMode/NightModeG1/NightMode.svelte';
import NightModeV2 from '../DevicesSettings/NightMode/NightModeG1/NightModeV2.svelte';
import NightModeRGBW from '../DevicesSettings/NightMode/NightModeG1/NightModeRGBW.svelte';
import NightModeRGBWV2 from '../DevicesSettings/NightMode/NightModeG1/NightModeRGBWV2.svelte';
import OpenCloseTime from './Settings/SettingsG1/OpenCloseTime.svelte';
import PlugLightControl from './Settings/SettingsG1/PlugLightControl.svelte';
import PositioningControls from './Settings/SettingsG1/PositioningControls.svelte';
import PowerConsumption from './Settings/SettingsG1/PowerConsumption.svelte';
import PowerOn from './Settings/SettingsG1/PowerModes/PowerOn.svelte';
import PowerOn1L from './Settings/SettingsG1/PowerModes/PowerOn1L.svelte';
import PowerOnRoller from './Settings/SettingsG1/PowerModes/PowerOnRoller.svelte';
import PowerOnRR from './Settings/SettingsG1/PowerModes/PowerOnRR.svelte';
import RangeExtenders from './Settings/SettingsG1/RangeExtenders.svelte';
import RelayLightControl from './Settings/SettingsG1/RelayLightControl.svelte';
import RemainAwake from './Settings/SettingsG1/RemainAwake.svelte';
import ReverseDirections from './Settings/SettingsG1/ReverseDirections.svelte';
import SelfTest from './Settings/SettingsG1/SelfTest.svelte';
// import SensorMute from './Settings/SettingsG1//SensorMute.svelte';//This will be a button on device drawer
import SetVolume from './Settings/SettingsG1/SetVolume.svelte';
import SupplyVoltage from './Settings/SettingsG1/SupplyVoltage.svelte';
import SwapInputs1L from './Settings/SettingsG1/SwapInputs1L.svelte';
import SwapInputs from './Settings/SettingsG1/SwapInputs.svelte';
import TransformerCalibration from './Settings/SettingsG1/TransformerCalibration.svelte';
import TransformerType from './Settings/SettingsG1/TransformerType.svelte';
import TransitionTime from './Settings/SettingsG1/TransitionTime.svelte';
import TRVMinValve from './Settings/SettingsG1/TRV/TRVMinValve.svelte';
import UnderFloorHeating from './Settings/SettingsG1/TRV/UnderFloorHeating.svelte';
import WarmUp from './Settings/SettingsG1/WarmUp.svelte';
//#endregion Settings

import Share from './Share/Share.svelte';
import Scripts from './Scripts/Scripts.svelte';
import ScriptsG2 from './Scripts/ScriptsG2.svelte';
import ScriptsG2V2 from './Scripts/ScriptsG2V2.svelte';

//#endregion SubMenus

//#region G2
import AutoG2 from './Timers/TimersG2/AutoG2.svelte';
import AutoG2V2 from './Timers/TimersG2/AutoG2V2.svelte';
import AutoG2Emeter from './Timers/TimersG2/AutoG2Emeter.svelte';
import AutoG2EmeterV2 from './Timers/TimersG2/AutoG2EmeterV2.svelte';
import SchedulesG2 from './Schedules/SchedulesG2/SchedulesG2.svelte';
import SchedulesG2V2 from './Schedules/SchedulesG2/SchedulesG2V2.svelte';
import WebHooksG2 from './WebHooks/WebHooksG2/WebHooksG2.svelte';
import WebHooksG2V2 from './WebHooks/WebHooksG2/WebHooksG2V2.svelte';

//#region NetworksG2
import CloudG2 from './NetworkG2/CloudG2.svelte';
import DeviceAuthenticationG2 from './NetworkG2/DeviceAuthenticationG2.svelte';
import EthernetG2 from './NetworkG2/EthernetG2.svelte';
import LteSettingsG2 from './NetworkG2/LteSettingsG2.svelte';
import LocalNetworkMessagingG2 from './NetworkG2/LocalNetworkMessagingG2.svelte';
import MqttG2 from './NetworkG2/MqttG2.svelte';
import OutBoundWS from './NetworkG2/OutBoundWS.svelte';
import RangeExtender from './NetworkG2/RangeExtender.svelte';
import RpcOverUdp from './NetworkG2/RpcOverUdp.svelte';
import WifiClientBackupG2 from './NetworkG2/WifiClientBackupG2.svelte';
import WifiModeApG2 from './NetworkG2/WifiModeApG2.svelte';
import WifiModeClientG2 from './NetworkG2/WifiModeClientG2.svelte';
//#endregion NetworksG2

//#region SafetyG2
import MaxPowerProtectionG2 from './Safety/SafetyG2/MaxPowerProtectionG2.svelte';
import MaxCurrentProtectionG2 from './Safety/SafetyG2/MaxCurrentProtectionG2.svelte';
import MaxVoltageProtectionG2 from './Safety/SafetyG2/MaxVoltageProtectionG2.svelte';
import CbVoltageProtection from './Safety/SafetyG2/CbVoltageProtection.svelte';
import DimmerVoltageProtection from './Safety/SafetyG2/DimmerVoltageProtection.svelte';
//#endregion SafetyG2

//#region SettingsG2
import AnalogInputSettingsG2 from './Settings/SettingsG2/AnalogInputSettingsG2.svelte';
import ChannelNameG2 from './Settings/SettingsG2/ChannelNameG2.svelte';
import EcoModeG2 from './Settings/SettingsG2/EcoModeG2.svelte';
import EnhancedSecurityG2 from './Settings/SettingsG2/EnhancedSecurityG2.svelte';
import CoverProfile from './Settings/SettingsG2/CoverProfile.svelte';
import DeviceNameSys from './Settings/SettingsG2/DeviceNameSys.svelte';
import HighFrequencyModeG2 from './Settings/SettingsG2/HighFrequencyModeG2.svelte';
import InputOutputPlug from './Settings/SettingsG2/InputOutputSettings/InputOutputPlug.svelte';
import InputOutputWrapperG2 from './Settings/SettingsG2/InputOutputSettings/InputOutputWrapperG2.svelte';
import ApplySettingsConfig from './Settings/SettingsG2/ApplySettingsConfig.svelte';
import InvertSwitchG2 from './Settings/SettingsG2/InvertSwitchG2.svelte';
// import SelectInputG2 from './DeviceSettings/Gen_2/Settings/SelectInputG2.svelte';
import LedIndicatorsG2 from './Settings/SettingsG2/LedIndicatorsG2.svelte';
import LocationG2 from './Settings/SettingsG2/LocationG2.svelte';
import NightModeG2 from '../DevicesSettings/NightMode/NightModeG2/NightModeG2.svelte';
import NightModeG2V2 from '../DevicesSettings/NightMode/NightModeG2/NightModeG2V2.svelte';
// import TestUpdateG2 from './DeviceSettings/Gen_2/Settings/TestUpdateG2.svelte';

//#endregion SettingsG2

//#region RollerSettingsG2
import InputTypeG2 from './Settings/SettingsG2/InputOutputSettings/InputTypeG2.svelte';
import InputNameG2 from './Settings/SettingsG2/InputNameG2.svelte';
import ControlButtonModeG2 from './Settings/SettingsG2/ControlButtonModeG2.svelte';
import ReverseDirectionG2 from './Settings/SettingsG2/ReverseDirectionG2.svelte';
import SwapInputsG2 from './Settings/SettingsG2/SwapInputsG2.svelte';
import CalibrationG2 from './Settings/SettingsG2/CalibrationG2.svelte';
import ActionPowerOnG2Cover from './Settings/SettingsG2/ActionPowerOnG2Cover.svelte';
import ActionPowerOnG2 from './Settings/SettingsG2/ActionPowerOnG2.svelte';
import MovementTimeLimitsG2 from './Settings/SettingsG2/MovementTimeLimitsG2.svelte';
import ObstacleDetectiong2 from './Safety/SafetyG2/ObstacleDetectiong2.svelte';
import SafetySwitchG2 from './Safety/SafetyG2/SafetySwitchG2.svelte';
import IdlePowerThreshold from './Settings/SettingsG2/IdlePowerThreshold.svelte';
import IdleConfirmPeriod from './Settings/SettingsG2/IdleConfirmPeriod.svelte';
import LedIndicatorColorPlug from './Settings/SettingsG2/LedIndicatorColorPlug.svelte';
import LedIndicatorNightModePlug from './Settings/SettingsG2/LedIndicatorNightModePlug.svelte';
import DetachSwitchPlugS from './Settings/SettingsG2/DetachSwitchPlugS.svelte';
import DisplayModeG2 from './Settings/SettingsG2/DisplayModeG2.svelte';
import FavoritesG2 from './FavoritesG2.svelte';
import OvervoltageAutoRecovery from './Safety/SafetyG2/OvervoltageAutoRecovery.svelte';
import OverUnderVoltageAutoRecovery from './Safety/SafetyG2/OverUnderVoltageAutoRecovery.svelte';
import UnderVoltageG2 from './Safety/SafetyG2/UnderVoltageG2.svelte';
import BlinkModeSelector from './Settings/SettingsG2/BlinkModeSelector.svelte';
import ActionOnPowerOnG2Emeter from './Settings/SettingsG2/ActionOnPowerOnG2Emeter.svelte';
import PhaseSelector from './Settings/SettingsG2/PhaseSelector.svelte';
import PhaseCalibration from './Settings/SettingsG2/PhaseCalibration.svelte';
import TiltControl from './Settings/SettingsG2/TiltControl.svelte';

//#endregion RollerSettingsG2

//#endregion G2

//#region G3
import DaliConfiguration from './Settings/SettingsG3/DaliConfiguration.svelte';
import ProRgbwwpmProfile from './Settings/SettingsG2/ProRGBWWPMProfile.svelte';
import InputOutputWrapperG3Rgbww from './Settings/SettingsG2/InputOutputSettings/InputOutputWrapperG3RGBWW.svelte';
import InputOutputWrapperG3Dimmer from './Settings/SettingsG2/InputOutputSettings/InputOutputWrapperG3Dimmer.svelte';

import DeviceLedSysGW from './Settings/SettingsG3/DeviceLedSysGW.svelte';
import WarmUpDimmerG2 from './Settings/SettingsG2/WarmUpDimmerG2.svelte';
//#endregion

//#region GBLE
import ButtonFindMe from './SettingsGBLE/ButtonFindMe.svelte';
import BLEMotionBlindTime from './SettingsGBLE/MotionBlindTime.svelte';
import BLEMotionSensitivity from './SettingsGBLE/MotionSensitivity.svelte';
import BLEFirmwareUpdate from './SettingsGBLE/FirmwareUpdate.svelte';
import BLEFactoryReset from './SettingsGBLE/FactoryReset.svelte';
import DistanceUnit from './SettingsGBLE/DistanceUnit.svelte';
import DistanceRange from './SettingsGBLE/DistanceRange.svelte';
import MeasurementInterval from './SettingsGBLE/MeasurementInterval.svelte';
import AngleReportThreshold from './SettingsGBLE/AngleReportThreshold.svelte';
import WeatherStationDeviceLocation from '../WeatherStation/WeatherStationDeviceLocation.svelte';
import WeatherStationBleSettings from '../WeatherStation/Settings/WeatherStationBLESettings.svelte';
import FireGroup from './SettingsGBLE/FireGroupGBLESetting.svelte';
import TemperatureThresholdGBLE from './SettingsGBLE/OffsetThresholdGBLE/TemperatureTresholdGBLE.svelte';
import SmokeThresholdGBLE from './SettingsGBLE/OffsetThresholdGBLE/SmokeThresholdGBLE.svelte';
//#endregion GBLE

//#region CommonSettings
// Shared between G1 and G2, abstracted and used for both generations of devices to provide a similar UX
import DeviceInfo from './Settings/CommonSettings/DeviceInfo/DeviceInfo.svelte';
import TransferDevice from './Settings/CommonSettings/DeviceInfo/TransferDevice.svelte';
import DeleteDevice from './Settings/CommonSettings/DeviceInfo/DeleteDevice.svelte';
import FirmwareUpdate from './Settings/CommonSettings/FirmwareUpdate.svelte';
import GeoLocationAndTimeZone from './Settings/CommonSettings/GeoLocationAndTimeZone.svelte';
import DeviceReboot from './Settings/CommonSettings/DeviceReboot.svelte';
import FactoryReset from './Settings/CommonSettings/FactoryReset.svelte';

//#region ApplicationSettings
import ApplianceType from '../DevicesSettings/Settings/CommonSettings/ApplianceType.svelte';
import ConsumptionCalculation from './ApplicationSettings/ConsumptionCalculation.svelte';
import ConsumptionHierarchy from './ApplicationSettings/ConsumptionHierarchy.svelte';
import ExcludeEventLog from './ApplicationSettings/ExcludeEventLog.svelte';
import ExcludeForgottenLights from './ApplicationSettings/ExcludeForgottenLights.svelte';
import AIModel from './ApplicationSettings/AIModel/AIModel.svelte';

import InputState from './ApplicationSettings/InputState.svelte';
import PinLock from './ApplicationSettings/PinLock.svelte';
// import PinLockG2 from './ApplicationSettings/PinLockG2.svelte';
import SplitEmeters from './ApplicationSettings/SplitEmeters.svelte';
import ScreenSaverG2 from './Settings/SettingsG2/ScreenSaverG2.svelte';
import ScreenLockG2 from './Settings/SettingsG2/ScreenLockG2.svelte';
import ScreenOffG2 from './Settings/SettingsG2/ScreenOffG2.svelte';
import RgbwG2Profile from './Settings/SettingsG2/RGBWG2Profile.svelte';
import Pro3EmProfile from './Settings/SettingsG2/Pro3EmProfile.svelte';
import InputOutputWrapperG2Rgbw from './Settings/SettingsG2/InputOutputSettings/InputOutputWrapperG2RGBW.svelte';
import DefaultTransitionG2 from './Settings/SettingsG2/DefaultTransitionG2.svelte';
import UiSettingsG2 from './Settings/SettingsG2/UISettingsG2.svelte';
import RangeMapG2 from './Settings/SettingsG2/RangeMapG2.svelte';
import TransitionG2 from './Settings/SettingsG2/TransitionG2.svelte';
import InputTypePerIDG2 from './Settings/SettingsG2/InputOutputSettings/InputTypePerIDG2.svelte';
import InputNamePerIdg2 from './Settings/SettingsG2/InputOutputSettings/InputNamePerIDG2.svelte';
import InputInvertPerIdg2 from './Settings/SettingsG2/InputOutputSettings/InputInvertPerIDG2.svelte';
import SoftRebootG2 from './Settings/SettingsG2/SoftRebootG2.svelte';
import Thermostat from './Settings/SettingsG2/ThermostatsWallDisplay/Thermostat.svelte';
import MediaPlayerSettings from './Settings/SettingsG2/ThermostatsWallDisplay/MediaPlayerSettings.svelte';
import ThermostatsG2 from './Settings/SettingsG2/ThermostatsWallDisplay/ThermostatsG2.svelte';
import InputOutput010 from './Settings/SettingsG2/InputOutputSettings/InputOutput010.svelte';
import ButtonFadeRateG2 from './Settings/SettingsG2/ButtonFadeRateG2.svelte';
import InputTypeG2cover from './Settings/SettingsG2/InputOutputSettings/InputTypeG2cover.svelte';
import InputTypeG2DualCover from './Settings/SettingsG2/InputOutputSettings/InputTypeG2DualCover.svelte';
import MinBrightnessOnToggleG2 from './Settings/SettingsG2/MinBrightnessOnToggleG2.svelte';
import GammaDimmerG2 from './Settings/SettingsG2/GammaDimmerG2.svelte';
import DimmerCalibrateG2 from './Settings/SettingsG2/DimmerCalibrateG2.svelte';
import ButtonPresetsG2 from './Settings/SettingsG2/ButtonPresetsG2.svelte';
import ButtonPresetsProRgbww from './Settings/SettingsG2/ButtonPresetsProRGBWW.svelte';
import PhaseToPhaseG2 from './Settings/SettingsG2/PhaseToPhaseG2.svelte';
import EnableInputG2 from './Settings/SettingsG2/EnableInputG2.svelte';
import RaexMotorSpeedG2 from './Settings/SettingsG2/Raex/RaexMotorSpeedG2.svelte';
import RaexGestureControlG2 from './Settings/SettingsG2/Raex/RaexGestureControlG2.svelte';
import VirtualComponents from './VirtualComponents/VirtualComponents.svelte';
import VirtualComponentsV2 from './VirtualComponents/ComponentsV2/VirtualComponentsV2.svelte';
import ReverseMeasurementDirectionG2 from './Settings/SettingsG2/ReverseMeasurementDirectionG2.svelte';
import ReverseMeasurementDirectionMonophase from './Settings/SettingsG2/ReverseMeasurementDirectionMonophase.svelte';
import DaisyEMTariffSettings from './Settings/SettingsG2/DaisyEMTariffSettings.svelte';
import ChangeCTType from './Settings/SettingsG2/ChangeCTType.svelte';
import RaexInputsConfigurationG2 from './Settings/SettingsG2/Raex/RaexInputsConfigurationG2.svelte';
import VentoraFanBoostDefaults from './Settings/SettingsG2/VentoraFan/VentoraFanBoostDefaults.svelte';
import VentoraFanHumTrigger from './Settings/SettingsG2/VentoraFan/VentoraFanHumTrigger.svelte';
import VentoraFanIdleRefresh from './Settings/SettingsG2/VentoraFan/VentoraFanIdleRefresh.svelte';
import VentoraFanInMode from './Settings/SettingsG2/VentoraFan/VentoraFanInMode.svelte';
import VentoraFanLightTrigger from './Settings/SettingsG2/VentoraFan/VentoraFanLightTrigger.svelte';
import VentoraFanNightMode from './Settings/SettingsG2/VentoraFan/VentoraFanNightMode.svelte';
import VentoraFanRunMode from './Settings/SettingsG2/VentoraFan/VentoraFanRunMode.svelte';
import VentoraFanTempTrigger from './Settings/SettingsG2/VentoraFan/VentoraFanTempTrigger.svelte';

// Zendure
import MinCharge from '../Integrations/Zendure/MinCharge.svelte';
import MaxCharge from '../Integrations/Zendure/MaxCharge.svelte';
import OutputLimitVisualizer from '../Integrations/Zendure/OutputLimitVisualizer.svelte';
import InputLimit from '../Integrations/Zendure/InputLimit.svelte';

import CtRangeG2 from './Settings/SettingsG2/CTRangeG2.svelte';
import DeleteStoredDataG2 from './Settings/SettingsG2/DeleteStoredDataG2.svelte';
import PhaseResetG2 from './Settings/SettingsG2/PhaseResetG2.svelte';
import ChannelFromChannelCalibrationG2 from './Settings/SettingsG2/ChannelFromChannelCalibrationG2.svelte';
import MonitorPhaseSequence from './Settings/SettingsG2/MonitorPhaseSequence.svelte';
import ReactionDelay from './Settings/SettingsG2/ReactionDelay.svelte';
import VoltmeterSettingsPerIdg2 from './Settings/SettingsG2/InputOutputSettings/VoltmeterSettingsPerIDG2.svelte';
// import DeviceNotifications from './Settings/CommonSettings/DeviceNotifications.svelte';
import OfflineNotificationsSetting from './ApplicationSettings/NotificationSettings/OfflineNotificationsSetting.svelte';
import LowBatteryNotificationsSetting from './ApplicationSettings/NotificationSettings/LowBatteryNotificationsSetting.svelte';
// import TemperatureUnitKvs from "./SensorSettingsG2/TemperatureUnitKvs.svelte";
// import SwitchModeG2 from "./Settings/SettingsG2/SwitchModeG2.svelte";//maybe not needed because we have it inside input/output settings

//#endregion ApplicationSettings

//#endregion CommonSettings

//#region zWave imports
import AutoZ from './Timers/TimersZ/AutoZ.svelte';
import CalibrationZ from './Settings/SettingsZWave/CalibrationZ.svelte';
import InputTypeZ from './Settings/SettingsZWave/InputTypeZ.svelte';
import InvertOutputZ from './Settings/SettingsZWave/InvertOutputZ.svelte';
import SwapInputZ from './Settings/SettingsZWave/SwapInputZ.svelte';
import SwapOutputZ from './Settings/SettingsZWave/SwapOutputZ.svelte';
import PowerOnDefaultZ from './Settings/SettingsZWave/PowerOnDefaultZ.svelte';
import IdlePowerPeriodZ from './Settings/SettingsZWave/IdlePowerPeriodZ.svelte';
import MovementTimeLimitsZ from './Settings/SettingsZWave/MovementTimeLimitsZ.svelte';
import FactoryResetZ from './Settings/SettingsZWave/FactoryResetZ.svelte';
import SmokeAlarmZ from './Settings/SettingsZWave/SmokeAlarmZ.svelte';
import CoAlarmZ from './Settings/SettingsZWave/COAlarmZ.svelte';
import HeatAlarmZ from './Settings/SettingsZWave/HeatAlarmZ.svelte';
import WaterAlarmZ from './Settings/SettingsZWave/WaterAlarmZ.svelte';
import FirmwareUpdateZ from './Settings/SettingsZWave/FirmwareUpdateZ.svelte';
import FrequencyListenerG2 from './Settings/SettingsG2/FrequencyListenerG2.svelte';
import EnableInputPerIdg2 from './Settings/SettingsG2/EnableInputPerIDG2.svelte';
import InvertSwitchG2PerIdg2 from './Settings/SettingsG2/InvertSwitchG2PerIDG2.svelte';
import OperationalModeG2 from './Settings/SettingsG2/OperationalModeG2.svelte';
import OperationalCountersG2 from './Settings/SettingsG2/OperationalCountersG2.svelte';

//#region templates imports
//Irrigation
import IrrigationZonesSettings from '../XT1/Irrigation/IrrigationZonesSettings.svelte';
import IrrigationDurationOffset from '../XT1/Irrigation/IrrigationDurationOffset.svelte';
import IrrigationLimitEnabledZones from '../XT1/Irrigation/IrrigationLimitEnabledZones.svelte';
import IrrigationSequences from '../XT1/Irrigation/IrrigationSequences.svelte';
import EnableWeatherAPI from '../XT1/Irrigation/EnableWeatherAPI.svelte';
import BaseTemperature from '../XT1/Irrigation/BaseTemperature.svelte';
//Valve
import ValveActionOnPowerLost from '../XT1/Valve/ValveActionOnPowerLost.svelte';
import ValveActionOnPowerRestored from '../XT1/Valve/ValveActionOnPowerRestored.svelte';
import NeoValveSettings from '../XT1/NeoValve/NeoValveSettings.svelte';
import VirtualInput from './Settings/SettingsG2/InputOutputSettings/VirtualInput.svelte';
//Thermostat
import ThermostatChildLock from '../XT1/Thermostat/ThermostatChildLock.svelte';
import ThermostatAntiFreeze from '../XT1/Thermostat/ThermostatAntiFreeze.svelte';
import ThermostatPowerDownMemory from '../XT1/Thermostat/ThermostatPowerDownMemory.svelte';
import ThermostatAntiFreezeTemperature from '../XT1/Thermostat/ThermostatAntiFreezeTemperature.svelte';
import ThermostatTemperatureUnit from '../XT1/Thermostat/ThermostatTemperatureUnit.svelte';
import ThermostatTemperatureOffset from '../XT1/Thermostat/ThermostatTemperatureOffset.svelte';
import ThermostatHumidityOffset from '../XT1/Thermostat/ThermostatHumidityOffset.svelte';
import ThermostatHysteresis from '../XT1/Thermostat/ThermostatHysteresis.svelte';
import ThermostatTemperatureSettings from '../XT1/Thermostat/ThermostatTemperatureSettings.svelte';
//EvCharger
import EvChargerAutoBalance from '../XT1/EvCharger/Settings/EvChargerAutoBalance.svelte';
import EvChargerAutoCharge from '../XT1/EvCharger/Settings/EvChargerAutoCharge.svelte';
import EvChargerGlobalTimeLimit from '../XT1/EvCharger/Settings/EvChargerGlobalTimeLimit.svelte';
import EvChargerGlobalChargeLimit from '../XT1/EvCharger/Settings/EvChargerGlobalChargeLimit.svelte';
import EvChargerInsertHandshake from '../XT1/EvCharger/Settings/EvChargerInsertHandshake.svelte';
import EvChargerRandomizeDelay from '../XT1/EvCharger/Settings/EvChargerRandomizeDelay.svelte';
//Dehumidifier
import AutoOffDehumidifier from '../XT1/Dehumidifier/AutoOffDehumidifier.svelte';

//#region Blu TRV
import BluTrvCalibration from './VirtualComponents/BluTRV/BluTrvCalibration.svelte';
import BluTrvBehavior from './VirtualComponents/BluTRV/BluTrvBehavior.svelte';
import BluTrvInterface from './VirtualComponents/BluTRV/BluTrvInterface.svelte';
import BluTrvEnable from './VirtualComponents/BluTRV/BluTrvEnable.svelte';
import BluTrvTemperatureOffset from './VirtualComponents/BluTRV/BluTrvTemperatureOffset.svelte';
import BluTrvFWUpdate from './VirtualComponents/BluTRV/BluTrvFWUpdate.svelte';
import SchedulesBLUTRV from './VirtualComponents/BluTRV/SchedulesBLUTRV.svelte';
import BluTrvAttachedSensors from './VirtualComponents/BluTRV/BluTrvAttachedSensors.svelte';
import BluTrvBoostDurationOverride from './VirtualComponents/BluTRV/BluTrvBoostDurationOverride.svelte';
import BluTrvDefaultOpenWindowTargetTemp from './VirtualComponents/BluTRV/BluTrvDefaultOpenWindowTargetTemp.svelte';
import PeripheralDeviceSettings from './AddonSettingsG2/PeripheralDevice/PeripheralDeviceSettings.svelte';
import AlarmModeG2 from './SensorSettingsG2/FloodG2/AlarmModeG2.svelte';
import AutoDiffuserG2 from './Timers/TimersG2/AutoDiffuserG2.svelte';
import AutoDiffuserG2V2 from './Timers/TimersG2/AutoDiffuserG2V2.svelte';
import InputTypeWallDisplay from './Settings/SettingsG2/InputOutputSettings/InputTypeWallDisplay.svelte';
import OutputTypeG2 from './Settings/SettingsG2/InputOutputSettings/OutputTypeG2.svelte';
import ReverseMeasurementDirectionG2PlugPm from './Settings/SettingsG2/ReverseMeasurementDirectionG2PlugPm.svelte';
import StateHoldTimeG2 from './SensorSettingsG2/FloodG2/StateHoldTimeG2.svelte';
import PresenceConfiguration from './SensorSettingsG2/PresenceG4/PresenceConfiguration.svelte';
import PresenceFineTuning from './SensorSettingsG2/PresenceG4/PresenceFineTuning.svelte';
import PresenceLedNightMode from './SensorSettingsG2/PresenceG4/PresenceLedNightMode.svelte';
import BoostDiffuserG2 from './Settings/SettingsG2/BoostDiffuserG2.svelte';
import ButtonPresetsPlusRGBWPM from './Settings/SettingsG2/ButtonPresetsPlusRGBWPM.svelte';
import NoteSection from '../Drawer/DeviceDrawer/NoteSection.svelte';
import InformationBoard from '../Drawer/DeviceDrawer/InformationBoard.svelte';
import TempFavPositions from '../Drawer/DeviceDrawer/TempFavPositions.svelte';
import ReverseMeasurementDirectionG2Pm from './Settings/SettingsG2/ReverseMeasurementDirectionG2Pm.svelte';
import DeviceModeG2Cury from './Settings/SettingsG2/DeviceModeG2Cury.svelte';
import TemperatureOffsetGble from './SettingsGBLE/OffsetThresholdGBLE/TemperatureOffsetGBLE.svelte';
import HumidityOffsetGble from './SettingsGBLE/OffsetThresholdGBLE/HumidityOffsetGBLE.svelte';
import UtcOffsetGble from './SettingsGBLE/OffsetThresholdGBLE/UtcOffsetGBLE.svelte';
import DarkThresholdGble from './SettingsGBLE/OffsetThresholdGBLE/DarkThresholdGBLE.svelte';
import BrightThresholdGble from './SettingsGBLE/OffsetThresholdGBLE/BrightThresholdGBLE.svelte';
import PillPeripheralSettings from './AddonSettingsG2/PillPeripherals/PillPeripheralSettings.svelte';
import LedIndicatorsG2Cury from './Settings/SettingsG2/LedIndicatorsG2Cury.svelte';
import VialAutoSwitchingG2Cury from './Settings/SettingsG2/VialAutoSwitchingG2Cury.svelte';
import QuickTourGuide from '../Distance/QuickTourGuide.svelte';
import CameraZonesSettings from '../Camera/DeviceDrawer/CameraZones/CameraZonesSettings.svelte';
import CameraStreamsSettings from '../Camera/DeviceDrawer/CameraSettings/CameraStreamsSettings.svelte';
import CameraAudioSettings from '../Camera/DeviceDrawer/CameraSettings/CameraAudioSettings.svelte';
import CameraVideoOrientationSettings from '../Camera/DeviceDrawer/CameraSettings/CameraVideoOrientationSettings.svelte';
import CameraImageAdjustmentsSettings from '../Camera/DeviceDrawer/CameraSettings/CameraImageAdjustmentsSettings.svelte';
import CameraNightVisionSettings from '../Camera/DeviceDrawer/CameraSettings/CameraNightVisionSettings.svelte';
import CameraMotionSensitivitySettings from '../Camera/DeviceDrawer/CameraSettings/CameraMotionSensitivitySettings.svelte';
import CameraStatusLedSettings from '../Camera/DeviceDrawer/CameraSettings/CameraStatusLedSettings.svelte';
import CameraStorageSettings from '../Camera/DeviceDrawer/CameraSettings/CameraStorage/CameraStorageSettings.svelte';

//#endregion
//#region Bluetooth
import BluetoothG2 from './Settings/Bluetooth/BluetoothG2.svelte';
import BtAssignedDevices from './Settings/Bluetooth/BTAssignedDevices.svelte';
import BTRemoteControls from './Settings/Bluetooth/BTRemoteControls.svelte';
import BluetoothRpcTester from './Settings/Bluetooth/BluetoothRpcTester.svelte';
//#endregion
import LockInputsG2 from './Settings/SettingsG2/InputOutputSettings/LockInputsG2.svelte';
import ViewSwitching from '../Drawer/DeviceDrawer/ViewSwitching.svelte';
import MatterG2 from './NetworkG2/MatterG2.svelte';
import ClockFormatGBLE from './SettingsGBLE/ClockFormatGBLE.svelte';
import EditDevice from '../Drawer/DeviceDrawer/EditDevice.svelte';
import DeviceDetails from './Settings/DeviceDetails.svelte';
import DeviceLocation from './Settings/DeviceLocation.svelte';
import BluetoothGateway from './Settings/BluetoothGateway.svelte';
import DimScreenAfterG2 from './Settings/SettingsG2/DimScreenAfterG2.svelte';
import SysBtnToggleG2 from './Settings/SettingsG2/SysBtnToggleG2.svelte';

export const settings_list = {
	// #region General
	// for every devices except shared
	device_details: DeviceDetails,
	device_location: DeviceLocation,
	bluetooth_gateway: BluetoothGateway,
	note_section: NoteSection,
	information_board: InformationBoard,
	view_switching: ViewSwitching,
	edit_device: EditDevice,

	// BLU Distance specific app setting
	quick_tour_guide: QuickTourGuide,

	//Timers both G1 and G2
	auto: Auto,
	auto_v2: AutoV2,
	//#region G1

	schedule_settings: ScheduleSettings,
	schedule_settings_v2: SchedulesG1V2,
	schedules_trv: SchedulesTrv,
	actions: ActionsContext,
	actions_v2: ActionsContextV2,
	adc_actions: AdcActions,
	adc_automation: AdcAutomation,

	//#region SensorSettingsG1
	auto_t_trv: AutoTControlTrv,
	illumination_definitions: IlluminationThreshold,
	motion_illumination_definitions: MotionIlluminationDefinitions,
	tilt_functions: TiltFunctions,
	tamper_sensitivity: TamperSensitivity,
	sleep_time: SleepTime,
	vibration: Vibration,
	motion_settings: MotionSettings,
	motion_configuration_g4: MotionConfigurationG4,
	motion_sensor_settings_g4: MotionSensorSettingsG4,
	presence_ui_settings_g4: PresenceUISettingsG4,
	wake_up_by_lighting: WakeUpByLighting,
	reverse_open_close: ReverseOpenCloseLogic,
	temperature_offset_trv: TemperatureOffsetTrv,
	temperature_threshold: TemperatureThreshold,
	temperature_unit: TemperatureUnits,
	humidity_threshold: HumidityThreshold,
	humidity_offset: HumidityOffset,
	temperature_offset: TemperatureOffset,
	motion_led: MotionLed,
	motion_duration: MotionDuration,
	external_power: ExternalPower,
	sensor_actions: SensorActions,
	// new_sensor_actions: NewSensorActions,
	valve: Valve,
	rain_mode: RainMode,
	open_window: OpenWindow,
	//#endregion SensorSettingsG1

	//#region SensorSettingsG2
	temperature_unit_g2: TemperatureUnitG2,
	// temperature_unit_kvs: TemperatureUnitKvs,
	temperature_offset_g2: TemperatureOffsetG2,
	humidity_offset_g2: HumidityOffsetG2,
	temperature_threshold_g2: TemperatureThresholdG2,
	humidity_threshold_g2: HumidityThresholdG2,
	bright_threshold_g2: BrightThresholdG2,
	dark_threshold_g2: DarkThresholdG2,
	temperature_sensor_name_g2: SensorComponentNameG2,
	humidity_sensor_name_g2: SensorComponentNameG2,
	illuminance_sensor_name_g2: SensorComponentNameG2,
	ventora_temperature_settings: VentoraSensorSettingsGroup,
	ventora_humidity_settings: VentoraSensorSettingsGroup,
	ventora_illuminance_settings: VentoraSensorSettingsGroup,
	alarm_mode_g2: AlarmModeG2,
	state_hold_time_g2: StateHoldTimeG2,
	presence_configuration: PresenceConfiguration,
	presence_fine_tuning: PresenceFineTuning,
	presence_led_settings: PresenceLedNightMode,
	//#endregion SensorSettingsG2

	//#region ExternalSensorsG1
	ext_temperature_unit: ExtTemperatureUnit,
	ext_sensor_names: ExtSensorNames,
	ext_temperature_offset: ExtTemperatureOffset,
	ext_humidity_offset: ExtHumidityOffset,
	//#endregion ExternalSensorsG1

	//#region NetworkSettingsG1
	advanced_developer_settings: AdvancedDevSettings,
	cloud: Cloud,
	restrict_login: RestrictLogin,
	wifi_ap_roaming: WifiApRoaming,
	wifi_client_backup: WifiClientBackup,
	wifi_mode_ap: WifiModeAp,
	wifi_mode_client: WifiModeClient,
	wifi_reconnect: WifiReconnect,
	//#endregion NetworkSettingsG1

	//#region SafetyG1
	max_power_protection: PowerProtection,
	max_power_protection_em3: PowerProtectionEM3,
	max_power_protection_roller: PowerProtectionRoller,
	obstacle_detection: ObstacleDetection,
	overvoltage_auto_recovery_g2: OvervoltageAutoRecovery,
	over_under_voltage_auto_recovery_g2: OverUnderVoltageAutoRecovery,
	safety_switch: SafetySwitch,
	under_voltage_protection_g2: UnderVoltageG2,
	//#endregion SafetyG1

	favorites_gen_1: Favorites,

	//#region SettingsG1
	antiflickering_debounce: Antiflickering,
	adc_offset: AdcOffset,
	adc_range: AdcRange,
	boost_time: BoostTime,
	button_type: BtnType,
	button_type_1l: BtnType1L,
	button_type_1l2: BtnType1L2,
	button_type_inputs_reader: BtnTypeInputsReader,
	button_type_pm: BtnTypePM,
	button_type_rgbw2: BtnTypeRGBW2,
	button_type_rgbw2white: BtnTypeRGBW2White,
	button_type_roller: BtnTypeRoller,
	button_type_rr: BtnTypeRR,
	button_debounce: ButtonDebounce,
	buttons_fade_rate: ButtonFade,
	calibration_trv: CalibrationTrv,
	calibration_blu_trv: BluTrvCalibration,
	interface_blu_trv: BluTrvInterface,
	behavior_blu_trv: BluTrvBehavior,
	boost_duration_override: BluTrvBoostDurationOverride,
	open_window_target_temperature: BluTrvDefaultOpenWindowTargetTemp,
	enable_blu_trv: BluTrvEnable,
	temperature_offset_blu_trv: BluTrvTemperatureOffset,
	firmware_update_blu_trv: BluTrvFWUpdate,
	schedules_blu_trv: SchedulesBLUTRV,
	attached_sensors_blu_trv: BluTrvAttachedSensors,
	temperature_favorite_positions: TempFavPositions,
	channel_name: ChannelName,
	clog_prevention: ClogPrevention,
	consumption_correction: ConsumptionCorrection,
	consumption_indicator: ConsumptionIndicator,
	customize_device_content: CustomizeDeviceContent,
	dc_supply_voltage: DCSupply,
	device_name: DeviceName,
	dimmer_calibration: DimmerCalibration,
	display: Display,
	device_information: DeviceInfo,
	transfer_device: TransferDevice,
	delete_device: DeleteDevice,
	device_model: DeviceModel,
	device_reboot: DeviceReboot,
	eco_mode: EcoMode,
	ends_delay: EndsDelay,
	mode_rgb2: ModeRGBW2,
	erase_data: EraseData,
	ext_temperature_actions: TemperatureAutomation,
	ext_humidity_actions: HumidityAutomation,
	ext_switch: ExternalSwitch,
	factory_reset: FactoryReset,
	factory_reset_g1: FactoryResetG1,
	force_close: ForceCloseTrv,
	firmware_update: FirmwareUpdate,
	geo_location_and_time_zone: GeoLocationAndTimeZone,
	input_buttons_mode: InputBtnsMode,
	kids_protection: ChildLock,
	led_indicator_color_plus_plug_s: LedIndicatorColorPlug,
	led_indicator_night_mode_plus_plug_s: LedIndicatorNightModePlug,
	led_status_disable: RelayLightControl,
	led_status_disable_plug: PlugLightControl,
	led_light_control: DWLightControl,
	mos_light_control: MosLightControl,
	long_push: LongPush,
	long_push_inputs: LongPushInputs,
	min_brightness: MinBrightness,
	multi_push: MultiPush,
	mode: Mode,
	neutral_mismatch: NeutralMismatch,
	night_mode: NightMode,
	night_mode_v2: NightModeV2,
	night_mode_rgbw: NightModeRGBW,
	night_mode_rgbw_v2: NightModeRGBWV2,
	night_mode_g2: NightModeG2,
	night_mode_g2_v2: NightModeG2V2,
	open_close_working_time: OpenCloseTime,

	positioning_controls: PositioningControls,
	power_consumption: PowerConsumption,
	power_on_default: PowerOn,
	power_on_default_1l: PowerOn1L,
	power_on_default_roller: PowerOnRoller,
	power_on_default_rr: PowerOnRR,

	range_extenders: RangeExtenders,
	remain_awake: RemainAwake,
	reverse_directions: ReverseDirections,
	thermostat_settings_g2: Thermostat,
	media_player_settings_g2: MediaPlayerSettings,
	thermostats_g2: ThermostatsG2,
	transformer_calibration: TransformerCalibration,
	transformer_type: TransformerType,
	transition_time: TransitionTime,
	min_valve_trv: TRVMinValve,
	self_test: SelfTest,
	// sensor_mute: SensorMute,//this will be a device drawer button
	set_volume: SetVolume,
	supply_voltage: SupplyVoltage,
	swap_inputs_1l: SwapInputs1L,
	swap_inputs: SwapInputs,
	under_floor_heating: UnderFloorHeating,
	warm_up: WarmUp,
	//#endregion SettingsG1

	//#endregion G1

	//#region G2
	auto_gen_2: AutoG2,
	auto_gen_2_v2: AutoG2V2,
	auto_gen_2_emeter: AutoG2Emeter,
	auto_gen_2_emeter_v2: AutoG2EmeterV2,
	auto_diffuser_gen_2: AutoDiffuserG2,
	auto_diffuser_gen_2_v2: AutoDiffuserG2V2,
	schedule_gen_2: SchedulesG2,
	schedule_gen_2_v2: SchedulesG2V2,
	webhooks_gen_2: WebHooksG2,
	webhooks_gen_2_v2: WebHooksG2V2,

	//#region NetworkSettingsG2
	bluetooth_gen_2: BluetoothG2,
	cloud_gen_2: CloudG2,
	device_authentication_gen_2: DeviceAuthenticationG2,
	ethernet_gen_2: EthernetG2,
	lte_settings_gen_2: LteSettingsG2,
	mqtt_gen_2: MqttG2,
	local_network_messaging_g2: LocalNetworkMessagingG2,
	outbound_ws: OutBoundWS,
	rpc_over_udp: RpcOverUdp,
	range_extender_g2: RangeExtender,
	wifi_mode_ap_gen_2: WifiModeApG2,
	wifi_client_backup_gen_2: WifiClientBackupG2,
	wifi_mode_client_gen_2: WifiModeClientG2,
	matter_gen_2: MatterG2,
	//#endregion NetworkSettingsG2

	//#region SafetyG2
	max_power_protection_g2: MaxPowerProtectionG2,
	max_current_protection_g2: MaxCurrentProtectionG2,
	max_voltage_protection_g2: MaxVoltageProtectionG2,
	cb_voltage_protection: CbVoltageProtection,
	dimmer_voltage_protection: DimmerVoltageProtection,
	//#endregion SafetyG2

	addon_enable: EnableAddon,
	peripheral_device_settings: PeripheralDeviceSettings,
	plus_uni_counter: PlusUniCounterSettings,

	favorites_gen_2: FavoritesG2,

	//#region SettingsG2
	analog_input_settings_g2: AnalogInputSettingsG2, //rgbw analog input only
	blink_mode_selector: BlinkModeSelector,
	button_presets_g2: ButtonPresetsG2, //pro dimmer 1 and 2
	button_presets_prorgbww: ButtonPresetsProRgbww, // Pro RGBWW PM
	button_presets_plus_rgbw: ButtonPresetsPlusRGBWPM, // Plus RGBW PM
	channel_from_channel_calibration_g2: ChannelFromChannelCalibrationG2, //pro 3 em
	delete_stored_data_g2: DeleteStoredDataG2,
	device_name_g2: ChannelNameG2,
	device_name_sys: DeviceNameSys, // for gen2 sensor devices
	dimmer_calibrate_g2: DimmerCalibrateG2, //pro dimmer 1, 2 and Plus RGBW PM (light mode)
	high_frequency_mode_g2: HighFrequencyModeG2,
	input_name_g2: InputNameG2,
	input_output_plug: InputOutputPlug,
	input_output_g2: InputOutputWrapperG2,
	lock_inputs_g2: LockInputsG2,
	apply_settings_configuration: ApplySettingsConfig,
	virtual_input_g2: VirtualInput,
	assigned_bluetooth_devices_gen_2: BtAssignedDevices,
	bt_home_control_gen_2: BTRemoteControls,
	bluetooth_rpc_tester: BluetoothRpcTester,
	input_output_010: InputOutput010,
	input_output_g2_rgbw: InputOutputWrapperG2Rgbw,
	input_invert_per_id_g2: InputInvertPerIdg2,
	input_name_per_id_g2: InputNamePerIdg2,
	input_type_per_id_g2: InputTypePerIDG2,
	button_fade_rate_g2: ButtonFadeRateG2,
	min_brightness_on_toggle_g2: MinBrightnessOnToggleG2,
	gamma_dimmer_g2: GammaDimmerG2,
	operational_mode_g2: OperationalModeG2,
	operational_counters_g2: OperationalCountersG2,
	range_map_g2: RangeMapG2,
	ct_range_g2: CtRangeG2,
	reaction_delay_g2: ReactionDelay,
	reverse_measurement_direction_g2: ReverseMeasurementDirectionG2,
	reverse_measurement_direction_g2_plug_pm: ReverseMeasurementDirectionG2PlugPm,
	reverse_measurement_direction_g2_pm: ReverseMeasurementDirectionG2Pm,
	reverse_measurement_direction_monophase: ReverseMeasurementDirectionMonophase,
	daisy_em_tariff: DaisyEMTariffSettings,
	change_ct_type: ChangeCTType,
	default_transition_g2: DefaultTransitionG2,
	transition_g2: TransitionG2,
	invert_switch_g2: InvertSwitchG2,
	enable_input_g2: EnableInputG2,
	enable_input_per_id_g2: EnableInputPerIdg2,
	detach_switch_g2: DetachSwitchPlugS,
	// select_input_g2: SelectInputG2,
	display_mode_g2: DisplayModeG2,
	eco_mode_g2: EcoModeG2,
	enhanced_security_g2: EnhancedSecurityG2,
	boost_time_diffuser_gen_2: BoostDiffuserG2,
	ventora_fan_boost_defaults: VentoraFanBoostDefaults,
	ventora_fan_hum_trigger: VentoraFanHumTrigger,
	ventora_fan_idle_refresh: VentoraFanIdleRefresh,
	ventora_fan_in_mode: VentoraFanInMode,
	ventora_fan_light_trigger: VentoraFanLightTrigger,
	ventora_fan_night_mode: VentoraFanNightMode,
	ventora_fan_run_mode: VentoraFanRunMode,
	ventora_fan_temp_trigger: VentoraFanTempTrigger,
	cover_profile: CoverProfile,
	rgbw_g2_profile: RgbwG2Profile,
	pro3em_profile: Pro3EmProfile,
	led_indicators_g2: LedIndicatorsG2,
	led_indicators_g2_cury: LedIndicatorsG2Cury,
	vial_auto_switching_g2_cury: VialAutoSwitchingG2Cury,
	device_mode_g2_cury: DeviceModeG2Cury,
	location_g2: LocationG2,
	scripts_gen_2: Scripts,
	scripts_gen_2_v2: Scripts,
	warm_up_dimmer_g2: WarmUpDimmerG2,
	soft_reboot_g2: SoftRebootG2,
	input_type_g2: InputTypeG2,
	input_type_wall_display: InputTypeWallDisplay,
	output_type_g2: OutputTypeG2,
	// test_update_g2: TestUpdateG2,
	// device_notifications_settings: DeviceNotifications,
	offline_notifications_settings: OfflineNotificationsSetting,
	lowBattery_notifications_settings: LowBatteryNotificationsSetting,
	// overpower_notifications_settings: DeviceNotifications,
	// overvoltage_notifications_settings: DeviceNotifications,
	// overtemperature_notifications_settings: DeviceNotifications,
	voltmeter_settings_per_id_g2: VoltmeterSettingsPerIdg2,
	//#endregion SettingsG2

	//#region RollerSettingsG2
	action_on_power_on_g2_cover: ActionPowerOnG2Cover,
	action_on_power_on_g2: ActionPowerOnG2,
	action_on_power_on_g2_emeter: ActionOnPowerOnG2Emeter,
	calibration_g2: CalibrationG2,
	control_button_mode_g2: ControlButtonModeG2,
	frequency_listener_g2: FrequencyListenerG2,
	input_type_g2_cover: InputTypeG2cover,
	input_type_g2_dual_cover: InputTypeG2DualCover,
	invert_switch_per_id_g2: InvertSwitchG2PerIdg2,
	monitor_phase_sequence_g2: MonitorPhaseSequence,
	movement_time_limits_g2: MovementTimeLimitsG2,
	obstacle_detection_g2: ObstacleDetectiong2,
	phase_selector: PhaseSelector,
	phase_calibration: PhaseCalibration,
	phase_calibration_reset_g2: PhaseResetG2,
	phase_to_phase_g2: PhaseToPhaseG2,
	reverse_direction_g2: ReverseDirectionG2,
	swap_inputs_g2: SwapInputsG2,
	safety_switch_g2: SafetySwitchG2,
	gesture_control_g2: RaexGestureControlG2,
	motor_speed_g2: RaexMotorSpeedG2,
	// switch_mode_g2: SwitchModeG2,
	screen_lock_g2: ScreenLockG2,
	screen_off_g2: ScreenOffG2,
	dim_screen_after_g2: DimScreenAfterG2,
	sys_btn_toggle_g2: SysBtnToggleG2,
	screen_saver_g2: ScreenSaverG2,
	blinds_tilt_control_g2: TiltControl,
	ui_settings_g2: UiSettingsG2,
	idle_power_threshold_g2: IdlePowerThreshold,
	idle_confirm_period_g2: IdleConfirmPeriod,
	inputs_configuration_g2: RaexInputsConfigurationG2,
	//#endregion

	//#endregion G2

	//#region G3
	dali_configuration: DaliConfiguration,
	rgbww_g3_profile: ProRgbwwpmProfile,
	input_output_g3_rgbww: InputOutputWrapperG3Rgbww,
	input_output_g3_dimmer: InputOutputWrapperG3Dimmer,

	device_led_sys_gw: DeviceLedSysGW,

	pill_peripheral_settings: PillPeripheralSettings,
	//#endregion G3

	//#region GBLE

	find_ble: ButtonFindMe,
	motion_sensitivity_ble: BLEMotionSensitivity,
	motion_blind_time_ble: BLEMotionBlindTime,
	firmware_update_ble: BLEFirmwareUpdate,
	factory_reset_ble: BLEFactoryReset,
	distance_unit_ble: DistanceUnit,
	distance_range_ble: DistanceRange,
	measurement_interval_ble: MeasurementInterval,
	angle_report_threshold_ble: AngleReportThreshold,
	weather_station_device_location: WeatherStationDeviceLocation,
	weather_station_ble_settings: WeatherStationBleSettings,
	temperature_offset_ble: TemperatureOffsetGble,
	humidity_offset_ble: HumidityOffsetGble,
	utc_offset_ble: UtcOffsetGble,
	dark_threshold_ble: DarkThresholdGble,
	bright_threshold_ble: BrightThresholdGble,
	temperature_threshold_ble: TemperatureThresholdGBLE,
	smoke_threshold_ble: SmokeThresholdGBLE,
	clock_format_ble: ClockFormatGBLE,
	fire_group_ble: FireGroup,

	//#endregion GBLE

	//#region zendure

	min_charge: MinCharge,
	max_charge: MaxCharge,
	output_limit: OutputLimitVisualizer,
	input_limit: InputLimit,

	//#endregion zendure

	//#region camera
	camera_zones: CameraZonesSettings,
	camera_streams: CameraStreamsSettings,
	camera_audio: CameraAudioSettings,
	camera_video_orientation: CameraVideoOrientationSettings,
	camera_image_adjustments: CameraImageAdjustmentsSettings,
	camera_night_vision: CameraNightVisionSettings,
	camera_motion_sensitivity: CameraMotionSensitivitySettings,
	camera_status_led: CameraStatusLedSettings,
	camera_storage: CameraStorageSettings,
	//#endregion camera

	share: Share,

	//#region ApplicationSettings
	// appliance_type_g1: ApplianceTypeG1,
	appliance_type: ApplianceType,
	consumption_calculation: ConsumptionCalculation,
	exclude_event_log: ExcludeEventLog,
	exclude_forgotten_lights: ExcludeForgottenLights,
	pin_lock: PinLock,
	input_state: InputState,
	ai_model: AIModel,
	// test settings
	consumption_hierarchy: ConsumptionHierarchy,
	device_split: SplitEmeters,
	virtual_components: VirtualComponents,
	virtual_components_v2: VirtualComponentsV2,
	// Irrigation Controller
	irrigation_zones_settings: IrrigationZonesSettings,
	irrigation_sequences: IrrigationSequences,
	irrigation_duration_offset: IrrigationDurationOffset,
	limit_enabled_channels: IrrigationLimitEnabledZones,
	enable_weather_api: EnableWeatherAPI,
	base_temperature: BaseTemperature,
	// Valve Controller
	valve_action_on_power_lost: ValveActionOnPowerLost,
	valve_action_on_power_restored: ValveActionOnPowerRestored,
	valve_neo_valve_settings: NeoValveSettings,
	// Thermostat Controller
	thermostat_child_lock: ThermostatChildLock,
	thermostat_anti_freeze: ThermostatAntiFreeze,
	thermostat_power_down_memory: ThermostatPowerDownMemory,
	thermostat_temperature_unit: ThermostatTemperatureUnit,
	thermostat_anti_freeze_temp: ThermostatAntiFreezeTemperature,
	thermostat_temperature_offset: ThermostatTemperatureOffset,
	thermostat_humidity_offset: ThermostatHumidityOffset,
	thermostat_hysteresis: ThermostatHysteresis,
	thermostat_temperature_settings: ThermostatTemperatureSettings,
	// EvCharger Controller
	ev_charger_auto_balance: EvChargerAutoBalance,
	ev_charger_auto_charge: EvChargerAutoCharge,
	ev_charger_global_charge_limit: EvChargerGlobalChargeLimit,
	ev_charger_global_time_limit: EvChargerGlobalTimeLimit,
	ev_charger_insert_handshake: EvChargerInsertHandshake,
	ev_charger_randomize_delay: EvChargerRandomizeDelay,
	// Dehumidifier
	dehumidifier_auto_off_delay: AutoOffDehumidifier,

	//#endregion ApplicationSettings

	//#region zWave
	//gen Z timers
	auto_gen_z: AutoZ,
	calibration_z: CalibrationZ,
	co_alarm_z: CoAlarmZ,
	factory_reset_z: FactoryResetZ,
	firmware_update_z: FirmwareUpdateZ,
	heat_alarm_z: HeatAlarmZ,
	idle_power_period_z: IdlePowerPeriodZ,
	input_type_z: InputTypeZ,
	invert_output_z: InvertOutputZ,
	movement_time_limits_z: MovementTimeLimitsZ,
	power_on_default_z: PowerOnDefaultZ,
	smoke_alarm_z: SmokeAlarmZ,
	swap_inputs_z: SwapInputZ,
	swap_outputs_z: SwapOutputZ,
	water_alarm_z: WaterAlarmZ,
	//#endregion
};
